<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="ScheduleHistory" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { ScheduleHistoryProps } from './ScheduleHistory.ts';
import ScheduleHistory from './ScheduleHistory.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-schedule-history';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<ScheduleHistoryProps>();
const changableProps = useChangableProps(componentName, props);

</script>
